<template>
  <div class="terms container">
    <p><strong>Условия использования</strong></p>
    <p>&nbsp;</p>
    <p>
      <em
        ><span
          >Тот факт, что вы используете наш веб-сайт, находящийся по адресу
        </span></em
      ><a href="https://www.putinomics.ru"
        ><em><span>www.putinomics.ru</span></em></a
      ><em
        ><span>
          (и все относящиеся к нему связанные сайты, включая
        </span></em
      ><a href="https://www.putinomics.com"
        ><em><span>www.putinomics.com</span></em></a
      ><em
        ><span>
          и
          <a href="https://neo.putinomics.ru"
            ><em><span>neo.putinomics.ru</span></em></a
          >), или услуги ("Putinomics") подтверждает тот факт, что вы согласны с
          данными положениями и условиями использования ("Условия
          использования").&nbsp;</span
        ></em
      >
    </p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <ul>
      <li>
        <strong><strong>Термины</strong></strong>
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>
      <span>Документ составлен с учетом следующих определений и терминов:</span>
    </p>
    <ul>
      <li>
        <span>Веб-сайт &mdash; </span
        ><em><span>веб-сайт, находящийся по адресу </span></em
        ><a href="https://www.putinomics.ru"
          ><em><span>www.putinomics.ru</span></em></a
        ><em
          ><span>
            (и все относящиеся к нему связанные сайты, включая
          </span></em
        ><a href="https://www.putinomics.com"
          ><em><span>www.putinomics.com</span></em></a
        >
        и
        <a href="https://neo.putinomics.com"
          ><em><span>neo.putinomics.ru)</span></em></a
        >
      </li>
      <li>
        <span
          >Пользователь &mdash; любое лицо, имеющее доступ к Веб-сайту и/или
          использующее материалы (информацию), размещенные на Веб-сайте</span
        >
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <ul>
      <li>
        <strong
          ><strong
            >Условия использования информации (материалов) и отказ от
            ответственности</strong
          ></strong
        >
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>
      <span
        >Информация (материалы) на Веб-сайте предоставляется Пользователям для
        общего ознакомления и является информацией общего / образовательного
        характера. Информация (материалы), размещенная на Веб-сайте,
        предоставляется &laquo;как есть&raquo; безо всяких гарантий, включая
        гарантии коммерческой пригодности или доходности в будущем, и могут
        содержать неточности. Хотя Веб-сайт старается использовать только
        надежные источники, администрация Веб-сайта и любые лица, связанные с
        его управлением, не несут ответственности за достоверность
        предоставленной информации. Веб-сайт не гарантирует соответствия
        информации (материалов) ожиданиям или требованиям Пользователей.</span
      >
    </p>
    <p>
      <span>Любая информация (материалы), размещенная на Веб-сайте, </span
      ><strong>не является индивидуальной инвестиционной рекомендацией</strong
      ><span
        >. Финансовые инструменты либо операции, упомянутые в материалах, могут
        не подходить пользователям такого материала, не соответствовать их
        инвестиционному профилю, финансовому положению, опыту инвестиций,
        знаниям, инвестиционным целям, отношению к риску и доходности. Результат
        инвестирования в прошлом не определяет дохода в будущем. Оценка
        экономических рисков и выгод, возможных налоговых и юридических
        последствий, а также допустимости и целесообразности использования
        материалов является зоной ответственности пользователей таких
        материалов.</span
      >
    </p>
    <p>
      <span
        >Обращаем Ваше внимание, что операции с финансовыми инструментами могут
        быть сопряжены с явными и скрытыми издержками (расходами), включая но не
        ограничиваясь расходами на оплату брокерских и депозитарных услуг. Мы
        настоятельно рекомендуем ознакомиться Пользователями с возможными
        рисками, связанными с осуществлением операций с финансовыми
        инструментами.</span
      >
    </p>
    <p>
      <span
        >Веб-сайт не гарантирует, что любые качественные и количественные
        характеристики по информации (материалам), публикуемым на Веб-сайте, в
        частности, характеристики финансовых инструментов, являются
        достоверными. Любые новости, обсуждения, рыночные данные, инвестиционные
        идеи, прогнозы, исследования, анализ, цены, а также любые другие данные,
        представленные на Веб-сайте, является информацией по финансовым рынкам
        общего характера, предоставленной лишь в образовательных и
        развлекательных целях, и не представляет собой рекомендацию по
        инвестициям. Упоминаемые финансовые инструменты либо операции могут не
        соответствовать ожидаемой тем или иным пользователем сайта доходности,
        горизонту инвестирования, а также допустимому для того или иного
        пользователя сайта риску убытков. Новости, информация о корпоративных
        событиях, данные рынка, рекомендации, инвестиционные идеи, прогнозы, а
        также любая другая информация может быть изменена в любое время без
        уведомления. Putinomics не несет ответственности за какие-либо потери
        или убытки, включая, но не ограничиваясь этим, любые потери прибыли,
        обусловленные непосредственно или опосредованно использованием такой
        информации или доверием к ней.</span
      >
    </p>
    <p>
      <span
        >Любые материалы (информация), представленные на Веб-сайте, не могут
        рассматриваться как публичная оферта, предложение или приглашение к
        осуществлению действию, заключению договора на оказание услуг, покупке
        финансовых инструментов. Информация, размещенная на Веб-сайте, не
        является рекламой ценных бумаг (или иных финансовых инструментов).</span
      >
    </p>
    <p>
      <span
        >Веб-сайт не гарантирует, что информация (материалы) будут
        предоставляться непрерывно и без ошибок. Веб-сайт не гарантирует
        обеспечения доступа в будущем к любой информации (материалам) и
        необходимым для этого информационным системам и программам для
        электронных вычислительных машин.</span
      >
    </p>
    <p>
      <span
        >Все материалы, доступ к которым Пользователь получает на Веб-сайте, в
        том числе элементы дизайна, тексты, графика, фотографии, изображения,
        иллюстрации, видео, базы данных, музыка, звуки и прочее являются
        объектами исключительных прав администрации Веб-сайта и других
        правообладателей. Веб-сайт не гарантирует допустимость и правомерность
        использования Пользователями прав сторонних правообладателей. В случае,
        если обладателем информации (материалов), расположенных на Веб-сайте,
        являются сторонние правообладатели (не Веб-сайт), то трансляция или иное
        использование Пользователями такой информации допустимо только на
        условиях, установленных соответствующим правообладателем. Веб-сайт не
        использует материалы сторонних правообладателей в коммерческих
        целях.</span
      >
    </p>
    <p>
      <span
        >Перед началом использования Веб-сайта, Пользователь обязуется
        внимательно знакомиться с настоящим документом, тем самым выражая свое
        согласие с Ограничениями использования информации (материалов) и отказом
        от ответственности администрации Веб-сайта и любых лиц, связанных с
        управлением Веб-сайтом. Настоящий документ и соответствующие ограничения
        использования информации и отказ от ответственности могут быть изменены
        в одностороннем порядке без какого-либо специального уведомления
        Пользователей. Изменения вступают в силу с момента их размещения на
        Веб-сайте. В случае если Пользователь не согласен с какими-либо
        изменениями, ему следует прекратить использование Веб-сайта.</span
      >
    </p>
    <p>
      <span
        >Пользователь использует информацию (материалы) размещенные на Веб-сайте
        на свой собственный страх и риск и самостоятельно несет ответственность
        за возможные последствия такого использования. администрация Веб-сайта и
        любые лица, связанные с его управлением, не несут ответственности за
        возможные убытки и/или издержки Пользователей от использования
        информации (материалов), расположенных на Веб-сайте.</span
      >
    </p>
    <p>&nbsp;</p>
    <ol>
      <li>
        <strong>Условия использования информации Московской Биржи</strong>
      </li>
    </ol>
    <p>&nbsp;</p>
    <p>
      <span
        >Информация о торгах на рынках Группы &laquo;Московская Биржа&raquo;
        предоставлена ОАО Московская Биржа. Источником и владельцем биржевой
        информации является Московская Биржа.&nbsp;</span
      >
    </p>
    <p>
      <span
        >Без письменного согласия Биржи нельзя осуществлять дальнейшее
        распространение и предоставление биржевой информации в любом виде и
        любыми средствами, включая электронные, механические, фотокопировальные,
        записывающие или другие (в том числе с использованием удаленного
        мобильного (беспроводного) доступа), её трансляцию, в том числе
        средствами теле- и радиовещания, её демонстрацию на Интернет-сайтах, её
        использование в игровых, тренажерных и иных системах, предусматривающих
        демонстрацию и/или передачу биржевой информации, а также для расчёта
        производной информации (в том числе индексов и индикаторов),
        предназначенной для дальнейшего публичного распространения.</span
      >
    </p>
    <p>
      <span
        >Putinomics является дистрибьютором информации о ходе и итогах торгов на
        рынках Группы Московская Биржа.</span
      >
    </p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <ul>
      <li>
        <strong><strong>Политика файлов cookie</strong></strong>
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>
      <span
        >Мы используем файлы cookie браузера (небольшие текстовые файлы,
        размещенные на вашем устройстве), чтобы осуществлять работу Веб-сайта,
        собирать и анализировать статистические данные, обеспечивать
        безопасность и бороться со спамом, а также в целях рекламы. Файлы cookie
        позволяют предоставить вам более удобную работу с нашим Веб-сайтом, а
        также улучшить его функции.&nbsp;</span
      >
    </p>
    <p>
      <span
        >Мы обрабатываем файлы cookie браузера для того, чтобы удовлетворить
        интересам законного бизнеса, которые включают следующее:</span
      >
    </p>
    <ul>
      <li>
        <span
          >администрирование нашего Веб-сайта для лучшего понимания того, как
          пользователи взаимодействуют с Веб-сайтом и обеспечение наиболее
          эффективного алгоритма работы с вами и вашим компьютером/
          устройством;</span
        >
      </li>
      <li>
        <span
          >обезличивание, объединение и удаление идентификационной собранной
          информации и использование этих данных в целях наших внутренних
          бизнес-процессов, включая передачу таких данных нашим
          бизнес-партнерами, связанным компаниям, агентам и другим третьим лицам
          в коммерческих, статистических и маркетинговых целях.</span
        >
      </li>
      <li>
        <span
          >ведение бизнес/технических операций, включая выявление
          неисправностей, анализ показателей, тестирование, исследование,
          статистику и обзор, которые служат улучшению и созданию безопасной
          среды нашего Веб-сайта и наших информационных систем;</span
        >
      </li>
      <li>
        <span
          >(а) соблюдение установленного законодательства, (б) ответы на запросы
          официальных инстанций, (в) обеспечение исполнения наших Условий
          Использования или Правил; (г) защита деятельности компании и связанных
          организаций; (д) защита наших, ваших, а также прав связанных
          организаций, безопасности или собственности; (е) осуществление и
          защита законных прав или препятствование незаконным действиям. Это
          означает, что мы имеем право хранить и разглашать вашу информацию
          правоохранительным органам, государственным структурам, если мы
          обнаружим что такое разглашение необходимо для соблюдения закона. Это
          касается ответов на судебные предписания или повестки, а также другие
          судебные и регуляторные процессы.</span
        >
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <ul>
      <li>
        <strong><strong>Стороннее программное обеспечение</strong></strong>
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>
      <span
        >Наше программное обеспечение, веб-сайт и/или услуги могут включать
        программные компоненты, предоставляемые третьими лицами, которые
        применяются с разрешения непосредственного лицензиара и/или
        правообладателя на условиях данных лиц ("Стороннее программное
        обеспечение". Ресурс категорически отказывается от ответственности в
        гарантии или других обязательств в отношении Стороннего программного
        обеспечения.</span
      >
    </p>
    <p>
      <span
        >Стороннее программное обеспечение включает использование библиотеки
        графиков с открытым кодом TradingView (&ldquo;TradingView Lightweight
        Charts&rdquo;), распространяемой в соответствии с Apache License 2.0
        Copyright (с) 2019 TradingView, Inc. </span
      ><a href="https://www.tradingview.com/"
        ><span>https://www.tradingview.com/</span></a
      ><span>.</span>
    </p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <ul>
      <li>
        <strong><strong>Изменение условий использования</strong></strong>
      </li>
    </ul>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>
      <span
        >Данные Условия использования могут быть изменены в любой момент
        времени. Если вы продолжаете пользоваться услугами Веб-сайта после
        внесения изменений в Условия использования, вы подтверждаете, что
        согласны с изменениями. У вас всегда есть доступ к Условиям
        использования Веб-сайта, и вы можете проверить их на наличие изменений в
        любой момент. Перезагрузив страницу, перед вами появится самая последняя
        версия, доступная пользователям Веб-сайта.</span
      >
    </p>
  </div>
</template>

<script>
export default {
  mounted() {
    document.dispatchEvent(new Event('prerender-now'))
  },
}
</script>

<style lang="scss">
.terms {
  color: black;
  padding-top: 2rem;
}
</style>
